import { useCreateMutationHook } from "../../../lib/helpers";
import { FORGOT_PASSWORD_MUTATION } from "../../../network/mutations";

export const useForgotPassword = () => useCreateMutationHook('forgotPassword', FORGOT_PASSWORD_MUTATION);
